import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import * as utils from "../../Utils/comman";
import { useLoader } from "../../Loader";

function RejectModal({
  show,
  onHide,
  onReject,
  selectedOrder,
  getPurchaseOrder,
  action,
}) {
  const [comment, setComment] = useState("");
  const { startLoader, stopLoader } = useLoader();

  const handleReject = () => {
    startLoader();
    var bodyFormData = new FormData();
    bodyFormData.append("cer_id", selectedOrder.id);
    bodyFormData.append("status", action);
    bodyFormData.append("reject_reason", comment);

    utils
      .callAPI("post", `/cer/change-status`, bodyFormData)
      .then((res) => {
        if (typeof res !== "undefined") {
          getPurchaseOrder();
          onHide();
          setComment();
          stopLoader();
        } else {
          getPurchaseOrder();
          onHide();
          setComment();
          stopLoader();
        }
      })
      .catch((err) => {
        getPurchaseOrder();
        stopLoader();
      });
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Reject CER</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group controlId="rejectComment">
            <Form.Label>Reason</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              placeholder="Enter your reason reject "
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button variant="danger" onClick={handleReject}>
          Reject
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default RejectModal;
